export type FileDownloadRequestBody = {
  upload_result_id: string;
  file_type: FileTypeNumber;
};

export type FileDownloadResponse = {
  data: {
    download_url: string;
  };
};

export enum FileTypeNumber {
  EXCEL = 0,
  CSV = 1,
}
